import React, { HTMLAttributes } from "react"

interface SVGComponent extends HTMLAttributes<HTMLOrSVGElement> {}

export const BackgroundImage = ({ ...rest }: SVGComponent) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1221.002"
    height="622.586"
    viewBox="0 0 1221.002 622.586"
    {...rest}
  >
    <path
      id="container"
      d="M-18052.361-16344.769s124.641-180.47,270.113-161.271,165.965,137.623,256.268,145.279,311-35.271,323.945,201.462-141.908,303.938-232.721,263.321-151.33-60.521-210.582-43.53-117.619,46.047-203.053,43.53-132.486-79.472-218.293-57-149.152,55.222-247.043,31.438-177.807-287.191-15.994-379.8S-18052.361-16344.769-18052.361-16344.769Z"
      transform="translate(18422.275 16507.469)"
    />
  </svg>
)
